import { Page } from '@/core/architecture'

import { ForbiddenTemplate } from './template'

type Props = {
  /**
   * default: true
   * useNextRouter = true when this component use for nextjs page
   * useNextRouter = false when this component use inside react-route-dom
   */
  useNextRouter?: boolean
}

/**
 * Forbidden Page
 * Implemented as a practical sample.
 */
export const Forbidden: Page<Props> = ({ useNextRouter = true }) => {
  return <ForbiddenTemplate state={{ useNextRouter }} />
}
